import { BuilderElement, BuilderStore } from '@builder.io/react';

export interface SharedBuilderComponent {
  builderBlock?: BuilderElement;
  builderState?: BuilderStore;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  attributes?: any;
  backgroundColorClassName: string;
}

export type CtaVariant = 'primary' | 'secondary' | 'tertiary' | 'none';
export type ContentMobileBehavior = 'scroll' | 'swipe';

export type BuilderLocalized = {
  '@type': '@builder.io/core:LocalizedValue';
  [key: string]: string;
};

export type BuilderString = string | BuilderLocalized;

export enum LinkTarget {
  CURRENT_WINDOW = '_self',
  NEW_WINDOW = '_blank',
}
